import Modal from 'components/Common/Modal';
import TrialMainComponent from 'components/Trial';
import Typography from 'components/Atoms/Typography';
import CongratulationsModal from 'components/Common/CongratulationsModal';

import { getCookieData } from 'utils/cookieHandler';
import { getGitHubUrl } from 'utils/onboarding/framework';

import { sendAmplitudeEvents } from 'utils/common';
import { EventNames } from 'utils/events';
import { isEnterPressed } from 'utils/keyboard';

import usePlan from 'hooks/usePlan';

import history from 'utils/history';

import { Path } from 'constants/routes';

const queryString = require('query-string');

function AppBannerAndModals() {
  const {
    closePopup,
    commonUiVisual,
    handleContactSaleClick,
    handleUpgradeClick,
    isCustomTrial,
    runTestExternal,
    userData,
    userPlan,
    visual,
  } = usePlan();
  return (
    <>
      <Modal
        isOpen={
          visual && visual.planExpired && !visual.planExpiredFirstTimeShow
        }
        setIsOpen={() => closePopup('PLAN_EXPIRED')}
        promoBannerHeight
      >
        <TrialMainComponent
          handleContactSaleClick={handleContactSaleClick}
          handleUpgradeClick={handleUpgradeClick}
          isCustomTrial={isCustomTrial}
          type="PLAN_EXPIRED"
          userPlan={userPlan}
        />
      </Modal>
      <Modal
        isOpen={
          visual &&
          visual.limitExhausted &&
          !visual.limitExhaustedModalFirstTimeShow
        }
        setIsOpen={() => closePopup('LIMIT_EXHAUSTED')}
        promoBannerHeight
      >
        <TrialMainComponent
          type="LIMIT_EXHAUSTED"
          handleUpgradeClick={handleUpgradeClick}
          handleContactSaleClick={handleContactSaleClick}
          isCustomTrial={isCustomTrial}
          userPlan={userPlan}
        />
      </Modal>
      <Modal
        isOpen={
          visual &&
          visual.isLimitExhoustedThresholdNinty &&
          !visual.nintyPercentageThresholdModalFirstTimeShow &&
          !getCookieData('NINTY_PER_LIMIT_EXHAUSTED_THRESHOLD')
        }
        setIsOpen={() => closePopup('NINTY_PER_LIMIT_EXHAUSTED_THRESHOLD')}
        promoBannerHeight
      >
        <TrialMainComponent
          type="LIMIT_EXHAUSTED_THRESHOLD"
          threshold={visual && visual.thresholdValue}
          handleUpgradeClick={handleUpgradeClick}
          handleContactSaleClick={handleContactSaleClick}
          isCustomTrial={isCustomTrial}
          userPlan={userPlan}
        />
      </Modal>
      <Modal
        isOpen={
          visual &&
          visual.isLimitExhoustedThresholdSixty &&
          !visual.sixtyPercentageThresholdModalFirstTimeShow &&
          !getCookieData('SIXTY_PER_LIMIT_EXHAUSTED_THRESHOLD')
        }
        setIsOpen={() => closePopup('SIXTY_PER_LIMIT_EXHAUSTED_THRESHOLD')}
        promoBannerHeight
      >
        <TrialMainComponent
          type="LIMIT_EXHAUSTED_THRESHOLD"
          threshold={visual && visual.thresholdValue}
          handleUpgradeClick={handleUpgradeClick}
          handleContactSaleClick={handleContactSaleClick}
          isCustomTrial={isCustomTrial}
          userPlan={userPlan}
        />
      </Modal>
      <Modal
        isOpen={
          visual &&
          visual.isLimitExhoustedThresholdTen &&
          !visual.tenPercentageThresholdModalFirstTimeShow &&
          !getCookieData('TEN_PER_LIMIT_EXHAUSTED_THRESHOLD')
        }
        setIsOpen={() => closePopup('TEN_PER_LIMIT_EXHAUSTED_THRESHOLD')}
        promoBannerHeight
      >
        <TrialMainComponent
          type="LIMIT_EXHAUSTED_THRESHOLD"
          threshold={visual && visual.thresholdValue}
          handleUpgradeClick={handleUpgradeClick}
          handleContactSaleClick={handleContactSaleClick}
          isCustomTrial={isCustomTrial}
          userPlan={userPlan}
        />
      </Modal>
      <Modal
        isOpen={visual && visual.trialFeatureModal}
        setIsOpen={() => closePopup('TRIAL_FEATURE')}
        promoBannerHeight
      >
        <TrialMainComponent
          type="TRIAL_FEATURE"
          handleUpgradeClick={handleUpgradeClick}
          handleContactSaleClick={handleContactSaleClick}
          isCustomTrial={isCustomTrial}
          userPlan={userPlan}
        />
      </Modal>
      <Modal
        isOpen={
          visual &&
          visual.isPaidPlanExpired &&
          !visual.paidPlanExpiredFirstTimeShow
        }
        setIsOpen={() => closePopup('PAID_PLAN_EXPIRED')}
        promoBannerHeight
      >
        <TrialMainComponent
          type="PAID_PLAN_EXPIRED"
          handleUpgradeClick={handleUpgradeClick}
          handleContactSaleClick={handleContactSaleClick}
        />
      </Modal>
      <Modal
        isOpen={
          visual &&
          visual.isPaidUsedPlanAboutToExpire &&
          !visual.isPaidUsedPlanAboutToExpireFirstTimeShow &&
          !getCookieData('PAID_NINTY_PER_LIMIT_EXHAUSTED_THRESHOLD')
        }
        setIsOpen={() => closePopup('PAID_NINTY_PER_LIMIT_EXHAUSTED_THRESHOLD')}
        promoBannerHeight
      >
        <TrialMainComponent
          type="PAID_NINTY_PER_LIMIT_EXHAUSTED_THRESHOLD"
          handleUpgradeClick={handleUpgradeClick}
          handleContactSaleClick={handleContactSaleClick}
        />
      </Modal>
      <Modal
        isOpen={commonUiVisual && commonUiVisual.continueToGitpodModal}
        setIsOpen={() => runTestExternal({ continueToGitpodModal: false })}
        type="allowPopUp"
        promoBannerHeight
      >
        <Typography
          variant="h2"
          color="ltw-text-secondary"
          fontSize="ltw-text-16"
          fontType="ltw-font-semibold"
          lineHeight="ltw-leading-19"
        >
          Do you want to continue to Gitpod?
        </Typography>
        <div className="ltw-flex ltw-justify-end ltw-items-center ltw-gap-20px ltw-mb-10px ltw-mt-15px">
          <div
            onClick={() => runTestExternal({ continueToGitpodModal: false })}
            onKeyDown={(e) =>
              isEnterPressed(e) &&
              runTestExternal({ continueToGitpodModal: false })
            }
            role="button"
            tabIndex="0"
            className="cancel-gitpod-proceed"
          >
            <Typography
              variant="h2"
              color="ltw-text-secondary"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Cancel
            </Typography>
          </div>
          <div
            onClick={() => {
              const parsed = queryString.parse(window.location.search);
              let framework = parsed.framework;
              let frameworkType = parsed.frameworkType || '';
              if (!framework) {
                framework = commonUiVisual && commonUiVisual.frameworkName;
              }
              window.open(
                `https://gitpod.io/#LT_USERNAME=${
                  userData && userData.username
                },LT_ACCESS_KEY=${userData && userData.apiToken}/${getGitHubUrl(
                  framework,
                  frameworkType
                )}`,
                '_blank'
              );
              runTestExternal({ continueToGitpodModal: false });
              sendAmplitudeEvents(EventNames.HYP_GITPOD_GITHUB, {
                framework: framework,
              });
            }}
            onKeyDown={(e) => {
              isEnterPressed(e) &&
                runTestExternal({ continueToGitpodModal: false });
            }}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-gap-9px ltw-border ltw-border-primary ltw-bg-primary ltw-rounded ltw-px-20px ltw-py-10px"
            role="button"
            tabIndex="0"
          >
            <Typography
              variant="h2"
              color="ltw-text-white"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Proceed
            </Typography>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={commonUiVisual && commonUiVisual.existingUserGoToDashboard}
        setIsOpen={() => runTestExternal({ existingUserGoToDashboard: false })}
        type="allowPopUp"
        promoBannerHeight
      >
        <Typography
          variant="h2"
          color="ltw-text-secondary"
          fontSize="ltw-text-16"
          fontType="ltw-font-semibold"
          lineHeight="ltw-leading-19"
        >
          We detected you ran a test. Do you want to go to the Dashboard?
        </Typography>
        <div className="ltw-flex ltw-justify-end ltw-items-center ltw-gap-20px ltw-mb-10px ltw-mt-15px">
          <div
            onClick={() =>
              runTestExternal({ existingUserGoToDashboard: false })
            }
            onKeyDown={(e) =>
              isEnterPressed(e) &&
              runTestExternal({ existingUserGoToDashboard: false })
            }
            role="button"
            tabIndex="0"
            className="cancel-gitpod-proceed"
          >
            <Typography
              variant="h2"
              color="ltw-text-secondary"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Cancel
            </Typography>
          </div>
          <div
            onClick={() => {
              history.push(Path.ROOT);
              runTestExternal({
                existingUserGoToDashboard: false,
              });
            }}
            onKeyDown={(e) => {
              isEnterPressed(e) &&
                runTestExternal({ existingUserGoToDashboard: false });
            }}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-gap-9px ltw-border ltw-border-primary ltw-bg-primary ltw-rounded ltw-px-20px ltw-py-10px"
            role="button"
            tabIndex="0"
          >
            <Typography
              variant="h2"
              color="ltw-text-white"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Proceed
            </Typography>
          </div>
        </div>
      </Modal>
      {visual.enableCongratulationModal && <CongratulationsModal />}
    </>
  );
}

export default AppBannerAndModals;
